export default __webpack_public_path__ + "static/media/21.7848f1ee.png";